import { Directive, inject, TemplateRef } from '@angular/core';

/**
 * Marks an `<ng-template>` as the custom trigger content of an `immo-entity-select`.
 * The template receives the currently selected option as `$implicit`.
 */
@Directive({
    selector: '[immoEntitySelectTrigger]',
})
export class EntitySelectTriggerDirective {

    public template = inject(TemplateRef<any>);
}
